import React from 'react';

const SortingArrows = ({ order, active, direction: directionProp }) => {
   let direction;
   if (order) {
      direction = order;
   } else if (!order && active && directionProp) {
      direction = directionProp;
   }

   return (
      <>
         {!direction && <span className='text-gray2'><i className='fas fa-sort-alt ml-1' /></span>}
         {direction === 'asc' && <span className='text-gray'><i className='fas fa-long-arrow-alt-up ml-1' /></span>}
         {direction === 'desc' && <span className='text-gray'><i className='fas fa-long-arrow-alt-down ml-1' /></span>}
      </>
   );
};

export default SortingArrows;
